import axiosClient from '../axiosClient';

const offerAPI = {
    async getListOfferAPI(params) {
        const url = `/offer`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getHistoryTopUpAPI(params) {
        const url = `/contributor_transaction/list_transaction/status`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getHistoryWithdrawAPI(params) {
        const url = `/contributor_transaction/list_transaction/status`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getContributorTransactionList(params) {
        const url = `/contributor_transaction`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneOfferAPI(id, params){
        const url = `/offer/${id}`;
        const resp = await axiosClient.get(url, {params});
        return resp;
    }
};

export default offerAPI;
